import script from "./PgmInoutAuto.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmInoutAuto.vue?vue&type=script&setup=true&lang=ts"

import "./PgmInoutAuto.vue?vue&type=style&index=0&id=230bdc4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230bdc4e"]])

export default __exports__